<!--
  	author: tongfei@ytzhihui.com
  	date: 2019/02/21
 -->
<!--
	For Example:

    <tableList :tableParam='tableParam' @change='tableChange'></tableList>

		data(){
			return{
				tableParam: {    //===========================================> 参数值为boolean型的默认都是false, 参数为false的可不传
					dataRes: { entities:null }, //接口数据data
                    isCheckbox: true, //是否有选中checkbox栏  false没有，true有
                    isSingle:true,
                    singleId:'gid',
                    isCurrentRow: true,  //是否需要选中一行高亮
                    isDragSelected: true,  //是否需要表格拖拽选中
                    isIndex:true,  // 是否有序号
					bySort:{ prop: 'batchNum', order: 'descending'},  // prop:默认的排序的列，order:默认排序的顺序(升:ascending, 降:descending)
					columns: [  //table head 表头
						{ prop: 'batchNum', label: '套书编号', isSort: true, isHide: true }, //===========================================> isHide: 是否隐藏
                        { prop: 'orderStatus', label: '是否审核', enum:true, enumDeel: function(index, row){    //===========> enum: 是否枚举   enumDeel：处理返回值
                            let str = '';
                            if(row.orderStatus == '2'){
                                str = '已审核';
                            }else if(row.orderStatus == '1'){
                                str = '未提交';
                            }
                            return str; 
                        },
                        { prop: 'orderStatus', label: '是否审核', enum:true, enumDeel: function(index, row){    //===========> enum: 是否枚举   enumDeel：处理返回值
                            let str = [];
                            if(row.nfdf){
                                str.push({
                                    html: '不能',  //html:除了elementUI的组件节点，可随意输入html结构
                                    event: 'edit'
                                });
                            }else{
                                str.push({
                                    html: '<button type="button" class="el-button table-btn el-button--default">能</button>',
                                    event: 'cat'
                                });
                            }
                            return str;  //返回数组
                        },
						{ prop: 'tsmc', label: '套书名', width:'150px', isSort: true, isTip:true, align:'left', props:'contname', poptip: { title:'提示语', content: '', width:'200', trigger:'hover', placement:'top-start' } },  //===========> isTip：是否有提示语。props:提示行信息 poptip：提示语内容
						{ prop: 'cz', label: '操作', isChange:true, deel:[
                            {str:'去审核', event:'check'},     //===========================================> 没有type时就是 类型自定义
                            {str:'修改', event:'editor', hasPro: true }, // hasPro ：是否有进度条
                            {str:'验收', event:'check', hasPro: true , props:'qtcs', propsVal:'200',propsTerm: "!"},//======> event: 来判断，判断不同事件的分类处理；props：根据orderType字段的值propsVal判断是否需要按钮, propsTerm 用来指定等于还是非等于
                            {str:'jd', type:'progress', color:'#15b200', showText:false, initText: 'jdText' }   //==========> type='progress'：进度条类型，str：传值(进度百分比)对应的字段, showText：是否显示百分比，initText: 显示的文字传值对应的字段名, color：精度条颜色
                            {str:'orderType', type:'switch', event:'active'}   //================================> type='switch'时，str 传对应的字段（如：需要获取字段orderType的状态）
                        ] },
						{ prop: 'editorContent', label: '输入内容', width:'240px', isChange:true, deel:[  // 注意：这是输入框编辑 prop固定参数值editorContent
                            {str:'tsmc', type:'editorInput' }   //==========> 
                        ] },
					], 
					isPagination:true, // 是否有分页
                }
			}
		},
		methods: {
			/** 处理事件
             ** data值为：{event: event, index: index, row: row}
             ***********  event: 事件方式
             ***********  index: 指定行索引
             ***********  row: 指定行数据
            */
			getTableData() {
                let t = this;
                // t.$http.get('/bls/v2/serialbooks/pt/search/action/page?tsbm=&tsmc=&isbn=&smbh=&cbs=&cbtm=&bookName=&zz=&bc=&pageNum=1&pageSize=15', {params: ''}).then(res => {
                //     t.tableParam.dataRes = res.data;
                // }).catch(res => {
                //     console.log('查询出错');
                // })

                t.tableParam.dataRes.entities.forEach((ele,i) => {
                    let precentage = Math.floor(t.tableParam.dataRes.entities[i].qscs/t.tableParam.dataRes.entities[i].yycs*100);
                    t.$set(t.tableParam.dataRes.entities[i], 'jd', precentage);
                    let jdtext = t.tableParam.dataRes.entities[i].qscs+'/'+t.tableParam.dataRes.entities[i].yycs;
                    t.$set(t.tableParam.dataRes.entities[i], 'jdText', jdtext);
                    //添加勾选框是否禁用字段，isSelect（固定变量）
                    let isSelect = true;
                    if(precentage < 100) {                        
                        isSelect = false;
                    }else{
                        isSelect = true;
                    }
                    t.$set(t.tableParam.dataRes.entities[i], 'isSelect', isSelect);
                });
            },
            getCheckedData(){
                console.log(this.$refs.table.getSelection());
            },
            tableChange(data) {   // 操作事件
                if(data.event == 'downArrowKey'){
                    console.log(data.index);
                    console.log(data.row);
                }else if(data.event == 'editor'){
                    console.log(data.index);
                    console.log(data.row);
                }
            }
		}
 -->

<template>
    <div class="table-wrap" contenteditable="false">
        <el-table ref="multipleTable" v-drag :highlight-current-row="tableParam.isCurrentRow" :data="tableParam.dataRes.entities"
            border :max-height="tableParam.maxheight" :default-sort="tableParam.bySort" @current-change="TrCurrentChange"
            @sort-change="sortChange" @select="selectChange" @select-all="selectAllChange" @selection-change="handleSelectionChange"
            :span-method="colsSpan" :cell-style="cellStyle" :header-cell-style="headerCellStyle" @cell-click="cellClick"
            @header-click="headerClick" fit stripe style="width: 100%;">
            <el-table-column :selectable="selectable" type="selection" v-if="tableParam.isCheckbox" align="center"
                width="30">
            </el-table-column>
            <el-table-column v-else-if="tableParam.isSingle" align="center" width="30">
                <template slot-scope="scope">
                    <el-radio class="single_select" :label="scope.row[tableParam.singleId]" v-model="templateGidRadio"
                        @change.native="getSingleRow(scope.$index,scope.row)"> </el-radio>
                </template>
            </el-table-column>
            <el-table-column type="index" v-if="tableParam.isIndex" label="序号" align="center"></el-table-column>
            <template v-for="(item, index) in tableParam.columns">
                <!-- <el-table-column v-if="item.isProgress" :prop="item.prop" :sortable="item.isSort" :label="item.label" :align="item.align || 'center'" :width="item.width">    
                    <template slot-scope="scope">
                        <template v-for="x in item.deel">                       
                            <el-progress :percentage="scope.row[item.prop]" :color="x.color" :show-text="x.showText"></el-progress>
                            <span class="pre-text" v-html="scope.row[x.initText]"></span>
                        </template>
                    </template>
                </el-table-column>    -->
                <template v-if="!item.isHide">
                    <el-table-column :key="index" v-if="item.isChange" :prop="item.prop" :sortable="item.isSort" :label="item.label"
                        :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <div class="span-wrap">
                                <template v-for="(x,ix) in item.deel">
                                    <template v-if="x.type=='switch'">
                                        <template v-if="x.propsTerm && x.propsTerm == '!'">
                                            <span class="cont" :key="ix" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] != x.propsVal))) || !x.props"
                                                @click.stop="eventClick(x.event, scope.$index, scope.row)">
                                                <el-switch v-model="scope.row[x.str]" disabled :active-value="0"
                                                    :inactive-value="1" active-color="#13ce66" inactive-color="#dcdfe6"></el-switch>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span class="cont" :key="ix" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] == x.propsVal))) || !x.props"
                                                @click.stop="eventClick(x.event, scope.$index, scope.row)">
                                                <el-switch v-model="scope.row[x.str]" disabled :active-value="0"
                                                    :inactive-value="1" active-color="#13ce66" inactive-color="#dcdfe6"></el-switch>
                                            </span>
                                        </template>
                                    </template>
                                    <template v-else-if="x.type=='editorInput'">
                                        <div :key="ix" class="editable_input">
                                            <span v-show="!scope.row.flag">{{ scope.row[x.str] }}</span>
                                            <input class="editable" v-show="scope.row.flag" v-model="scope.row[x.str]"
                                                @click.stop="bindtext" @input="bindtext" @keyup.enter="editorEnterClick(scope.$index)"
                                                @blur="editorBlurFun(scope.$index ,x.str, editableCont, editBeforeVal)">
                                            <i class="iconfont icon-xiugai" @click.stop="handleEditorInput(scope.row, scope.row[x.str])"></i>
                                        </div>
                                    </template>
                                    <template v-else-if="x.type=='progress'">
                                        <div :key="ix" class="progress-wrap" v-if="!scope.row.isSelect && (typeof scope.row.isSelect) != 'undefined'">
                                            <el-progress :percentage="scope.row[x.str]" :color="x.color" :show-text="x.showText"></el-progress>
                                            <i class="el-icon-error" @click.stop="stopProgress(scope.$index)"></i>
                                            <span class="pre-text" v-html="scope.row[x.initText]" :style="{color:x.color}"></span>
                                        </div>
                                    </template>
                                    <template v-else-if="x.type=='button'">
                                        <template v-if="x.propsTerm && x.propsTerm == '!'">
                                            <span :key="ix" class="cont" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] != x.propsVal))) || !x.props">
                                                <el-button @click.stop="eventClick(x.event, scope.$index, scope.row)"
                                                    class="table-btn" size="mini" type="primary" plain :disabled="x.disabled">{{
                                                    x.str }}</el-button>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span :key="ix" class="cont" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] == x.propsVal))) || !x.props">
                                            </span>
                                        </template>
                                    </template>
                                    <template v-else-if="x.type=='icon'">
                                        <span :key="ix" class="icon-style" @click.stop="addColumn(scope.column)">
                                            <i :class="x.class"></i>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <template v-if="x.hasPro">
                                            <template v-if="(typeof scope.row.isSelect) == 'undefined'">
                                                <template v-if="x.propsTerm && x.propsTerm == '!'">
                                                    <span :key="ix" class="cont text_blue" v-if="!scope.row.isSelect && ((x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] != x.propsVal))) || !x.props)"
                                                        v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                                </template>
                                                <template v-else>
                                                    <span :key="ix" class="cont text_blue" v-if="!scope.row.isSelect && ((x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] == x.propsVal))) || !x.props)"
                                                        v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="x.propsTerm && x.propsTerm == '!'">
                                                    <span :key="ix" class="cont text_blue" v-if="scope.row.isSelect && ((x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] != x.propsVal))) || !x.props)"
                                                        v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                                </template>
                                                <template v-else>
                                                    <span :key="ix" class="cont text_blue" v-if="scope.row.isSelect && ((x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] == x.propsVal))) || !x.props)"
                                                        v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="x.propsTerm && x.propsTerm == '!'">
                                                <span :key="ix" class="cont text_blue" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] != x.propsVal))) || !x.props"
                                                    v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                            </template>
                                            <template v-else>
                                                <span :key="ix" class="cont text_blue" v-if="(x.props && ((!x.propsVal && +scope.row[x.props]) || (x.propsVal && scope.row[x.props] == x.propsVal))) || !x.props"
                                                    v-html="x.str || scope.row[item.prop]" @click.stop="eventClick(x.event, scope.$index, scope.row)"></span>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else-if="item.enum" :prop="item.prop" :sortable="item.isSort"
                        :label="item.label" :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <template v-if="isArray(item.enumDeel(scope.$index, scope.row))">
                                <span v-for="(str,sx) in item.enumDeel(scope.$index, scope.row)" :key="sx" v-html="toHtml(str.html)"
                                    @click.stop="eventClick(str.event, scope.$index, scope.row)"></span>
                            </template>
                            <span v-else v-html="toHtml(item.enumDeel(scope.$index, scope.row))"></span>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else-if="item.isTip" :prop="item.prop" :sortable="item.isSort"
                        :label="item.label" :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row[item.props]" :placement="item.poptip.placement" :title="item.poptip.title"
                                :width="item.poptip.width" :trigger="item.poptip.trigger" :disabled="item.poptip.disabled"
                                :content="scope.row[item.props]">
                                <span slot="reference" class="text_blue">{{ scope.row[item.prop] }}</span>
                            </el-popover>
                            <span slot="reference" v-if="!scope.row[item.props]">{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else-if="item.popTable" :prop="item.prop" :sortable="item.isSort"
                        :label="item.label" :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <el-popover :placement="item.poptip.placement" :title="item.poptip.title" :width="item.poptip.width"
                                :trigger="item.poptip.trigger" :disabled="item.poptip.disabled" @show="eventClick(item.poptip.event, scope.$index, scope.row)">
                                <el-table :data="scope.row[item.poptip.tableDataProp]" class="pop-table" max-height="300">
                                    <template v-for="(t, i) in item.poptip.tableCols">
                                        <el-table-column :key="i" v-if="!t.isChange" :width="t.width" :property="t.prop"
                                            :label="t.label" :align="t.align || 'center'" :show-overflow-tooltip="true"></el-table-column>
                                        <el-table-column :key="i" v-else :width="t.width" :property="t.prop" :label="t.label"
                                            :align="t.align || 'center'">
                                            <template slot-scope="scope">
                                                <div class="span-wrap">
                                                    <template v-for="(y,j) in t.deel">
                                                        <span class="cont text_blue" :key="j" @click.stop="eventClick(y.event, scope.$index, scope.row)"
                                                            v-html="y.str"></span>
                                                    </template>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                                <span slot="reference" class="d-block">{{ scope.row[item.prop] }}<i class="more-icon" v-if="scope.row[item.moreProp]"></i></span>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else-if="item.isReader" :render-header="renderHeader" :prop="item.prop" :show-overflow-tooltip="true" :sortable="item.isSort" :label="item.label"
                        :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <div>{{ scope.row[item.prop] }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else-if="item.isDropdown" :prop="item.prop" :show-overflow-tooltip="true" :sortable="item.isSort" :label="item.label"
                        :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <el-dropdown>
                                <span class="el-dropdown-link delbtn">
                                    {{ item.dropText }}<i class="el-icon-caret-right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown" >
                                    <el-dropdown-item v-for="(t, i) in item.dropOpts" @click.native="dropdownClick(scope.$index, scope.row, t.prop)" :key="i">{{t.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                    <el-table-column :key="index" v-else :show-overflow-tooltip="true" :prop="item.prop" :sortable="item.isSort"
                        :label="item.label" :align="item.align || 'center'" :width="item.width">
                        <template slot-scope="scope">
                            <div>{{ scope.row[item.prop] }}</div>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </el-table>
        <el-pagination class="pagi-wrap" v-if="tableParam.isPagination" :current-page:async="tableParam.dataRes.currentPage"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="tableParam.dataRes.pageSize"
            :total="tableParam.dataRes.total" :page-sizes="this.pageSizes" layout="total, sizes, prev, pager, next, jumper" />
    </div>
</template>

<script>
    // import airContexMenu from 'libs/utils/contextMenu.js'
    import {  Pagination, Button, Switch, Popover, Progress, Loading, Radio ,Dropdown, DropdownMenu,DropdownItem} from 'element-ui'
    // import { pageSize } from 'common/utils/configure'
    // import { isArray } from 'libs/utils/dataType'
    import { clearTimeout } from 'timers';

    export default {
        name: 'tableList',
        props: {
            tableParam: Object,
            callbackfn: Function,//表格列或行合并回调
            cellcallback: Function,//设置单元格样式回调
            cellclickcallback: Function,//单元格点击回调
            rendereadercallback:Function//渲染表头列的样式
        },
        // 框选的指令        
        directives: {
            drag: {
                // 指令的定义
                inserted: function (el, binding, vnode) {
                    if (vnode.context.tableParam.isDragSelected) {
                        var oDiv = el;
                        //监听用户鼠标事件
                        oDiv.onmousedown = function (ev) {
                            let iArr = [], delArr = [];
                            if (ev.which == 1 && ev.ctrlKey) {

                                //确保用户在移动鼠标的时候只初始化一次选中
                                var flag = true;
                                //用来存储列表
                                var selList = [];
                                //获得指令下的dom对应的表格
                                var fileNodes = oDiv.querySelectorAll('.table-wrap>.el-table>.el-table__body-wrapper>table>tbody>tr');
                                var countI = 0;
                                //获得鼠标
                                var evt = window.event || arguments[0];
                                var startX = (evt.x || evt.clientX);
                                var startY = (evt.y || evt.clientY);
                                var top, left;
                                //时时获得
                                top = getY(oDiv);
                                left = getX(oDiv);
                                var selDiv = document.createElement('div');
                                selDiv.style.cssText = 'position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;z-index:1000;filter:alpha(opacity:60);opacity:0.6;display:none;';
                                selDiv.id = 'selectDiv';
                                document.getElementsByClassName('el-table__body-wrapper')[0].appendChild(selDiv);

                                selDiv.style.left = startX + 'px';
                                selDiv.style.top = startY + 'px';
                                var _x = null;
                                var _y = null;
                                vnode.context.clearEventBubble(evt);
                                // //鼠标拖动时画框                           
                                document.onmousemove = function (ev) {
                                    evt = window.event || arguments[0];
                                    _x = (evt.x || evt.clientX);
                                    _y = (evt.y || evt.clientY);
                                    //为了确定是点击事件还是移动事件
                                    if (Math.abs(_x - startX) < 5 && Math.abs(_y - startY) < 5) {
                                        return;
                                    }
                                    //为了确保只有一次的渲染每次框选都把默认选中为空
                                    if (flag) {
                                        //重置选中css
                                        for (var i = 0; i < fileNodes.length; i++) {
                                            if (fileNodes[i].className.indexOf('el-table__row') != -1) {
                                                // fileNodes[i].className = "el-table__row";
                                                selList.push(fileNodes[i]);
                                            }
                                        }
                                        flag = false;
                                    }
                                    // //打开开关
                                    vnode.context.mouseflag = true;
                                    if (vnode.context.mouseflag) {
                                        if (selDiv.style.display == 'none') {
                                            selDiv.style.display = '';
                                        }
                                        var scrolling = oDiv.getElementsByClassName('el-table__body-wrapper');
                                        selDiv.style.left = Math.min(_x, startX) - left + scrolling[0].scrollLeft + 'px';
                                        //30是表头的高度
                                        selDiv.style.top = Math.min(_y, startY) - top - 30 + scrolling[0].scrollTop + 'px';
                                        selDiv.style.width = Math.abs(_x - startX) + 'px';
                                        selDiv.style.height = Math.abs(_y - startY) + 'px';

                                        // ---------------- 关键算法确定列表的选中靠的是index---------------------
                                        //统计所有已经勾选的i
                                        let iTotal = [];
                                        vnode.context.selectRow.forEach((ele, i) => {
                                            // if(vnode.context.tableParam.dataRes.entities.indexOf(ele) != -1){
                                            iTotal.indexOf(vnode.context.tableParam.dataRes.entities.indexOf(ele)) == -1 && iTotal.push(vnode.context.tableParam.dataRes.entities.indexOf(ele));
                                            // }
                                        });

                                        var _l = selDiv.offsetLeft, _t = selDiv.offsetTop;
                                        var _w = selDiv.offsetWidth, _h = selDiv.offsetHeight;
                                        for (var i = 0; i < selList.length; i++) {
                                        /* */  var sl = selList[i].offsetWidth + selList[i].offsetLeft;
                                            var st = selList[i].offsetHeight + selList[i].offsetTop;
                                            let r = vnode.context.tableParam.dataRes.entities[i];
                                            if (!selList[i].classList.contains('dis-ckb')) {  // 屏蔽掉 不能勾选的行
                                                if (sl > _l && st > _t && selList[i].offsetLeft < _l + _w && selList[i].offsetTop < _t + _h) {
                                                    // console.log('iArr' + JSON.stringify(iArr));
                                                    // console.log('iTotal' + JSON.stringify(iTotal));
                                                    // console.log('delArr' + JSON.stringify(delArr));
                                                    if (vnode.context.selectRow.indexOf(r) == -1 && delArr.indexOf(i) == -1) {
                                                        iArr.push(i);       //iArr 保存正在拖拽时勾选的index 
                                                        vnode.context.$refs.multipleTable.toggleRowSelection(r, true)
                                                        //把选中的都存入到table标签中的已选中
                                                        if (r) {
                                                            vnode.context.selectRow.push(r);
                                                        }
                                                        // console.info('**'+i);
                                                        // 选中但并非此次选中
                                                    } else if (iArr.indexOf(i) == -1 && iTotal.indexOf(i) != -1) {
                                                        delArr.push(i);
                                                        // console.log(i);
                                                        vnode.context.$refs.multipleTable.toggleRowSelection(vnode.context.tableParam.dataRes.entities[i], false);
                                                    }
                                                } else {
                                                    if (vnode.context.selectRow.indexOf(r) != -1) {
                                                        // console.error(i);
                                                        if (iArr.indexOf(i) != -1) {
                                                            vnode.context.$refs.multipleTable.toggleRowSelection(vnode.context.tableParam.dataRes.entities[i], false);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    vnode.context.clearEventBubble(evt);
                                };
                                //在鼠标抬起后做的重置
                                document.onmouseup = function (e) {
                                    //把鼠标移动事初始化
                                    document.onmousemove = null;
                                    iArr = [], delArr = [];
                                    if (selDiv) {
                                        document.getElementsByClassName('el-table__body-wrapper')[0].removeChild(selDiv);
                                    }
                                    selList = null, _x = null, _y = null, selDiv = null, startX = null, startY = null, evt = null;
                                    vnode.context.mouseflag = false;
                                    // vnode.context.$handleSelect();
                                    vnode.context.selectRow = deteleObject(vnode.context.selectRow);
                                    vnode.context.$emit('change', { event: 'dragSelect', row: vnode.context.selectRow });
                                    e.stopPropagation();
                                };
                            }
                            //方法是确定列表到屏幕的位置
                            function getX(obj) {
                                var parObj = obj;
                                var left = obj.offsetLeft;
                                while (parObj = parObj.offsetParent) {
                                    left += parObj.offsetLeft;
                                }
                                return left;
                            }
                            //方法是确定列表到屏幕的位置
                            function getY(obj) {
                                var parObj = obj;
                                var top = obj.offsetTop;
                                while (parObj = parObj.offsetParent) {
                                    top += parObj.offsetTop;
                                }
                                return top;
                            }
                            // 去掉重复的数据
                            function deteleObject(obj) {
                                var uniques = [];
                                var stringify = {};
                                for (var i = 0; i < obj.length; i++) {
                                    var keys = Object.keys(obj[i]);
                                    keys.sort(function (a, b) {
                                        return (Number(a) - Number(b));
                                    });
                                    var str = '';
                                    for (var j = 0; j < keys.length; j++) {
                                        str += JSON.stringify(keys[j]);
                                        str += JSON.stringify(obj[i][keys[j]]);
                                    }
                                    if (!stringify.hasOwnProperty(str)) {
                                        uniques.push(obj[i]);
                                        stringify[str] = true;
                                    }
                                }
                                return uniques;
                            }
                        };
                    }
                }
            }
        },
        data() {
            return {
                //指令中确定的时候是鼠标按下事件
                mouseflag: false,
                DOC: [],  //定义table每行tr结构
                timer: null,
                rowIndex: '', // 保存临时编辑文本 行索引
                editBeforeVal: '', //保存编辑前的值
                editableCont: '', // 保存临时编辑文本
                pageSizes: [10, 20, 50, 100, 200],
                loadingInstance: null,
                currentIndex: 0,  // 声明行高亮，默认第一行
                currentRow: [],  // 声明行高亮数据
                selectRow: [],  // 声明获取选中行数据
                templateGidRadio: ''//单选id值
            }
        },
        components: { 'el-button': Button, 'el-pagination': Pagination, 'el-switch': Switch,
                     'el-popover': Popover, 'el-progress': Progress, Loading, 'el-radio': Radio ,
                     'el-dropdown': Dropdown, 'el-dropdown-menu':DropdownMenu,'el-dropdown-item':DropdownItem},
        computed: {
            // dheight() {
            //     if (this.$store) {
            //         return this.$store.state.detailH;
            //     }
            // }
        },
        watch: {
            tableParam: {
                handler: function (val, oldval) {
                    let t = this;
                    // if(t.tableParam.dataRes.total > 10000){
                    //     t.$set(t.tableParam.dataRes, 'total', 10000);
                    // }
                    t.$nextTick(() => {
                        let e = t.tableParam.dataRes.entities;
                        if (e && !t.tableParam.noDefualtHigh) {
                            t.currentIndex = e.length > t.currentIndex ? t.currentIndex : 0;//列表数据改变  选中行重置
                            t.currentRow = t.tableParam.dataRes.entities[t.currentIndex]; // 默认显示第一行高亮
                            t.$refs.multipleTable.setCurrentRow(t.currentRow);
                        }
                    })
                },
                immediate: true,//关键 
                deep: true
            },
            selectRow(newVal, oldVal) {  //监听选中行数据
                let t = this, a;
                if (t.tableParam.isCheckbox) {
                    // let doc = document.querySelector('.table-wrap .el-table__body').getElementsByTagName('tr');
                    for (a = 0; a < t.DOC.length; a++) {
                        for (var b = 0; b < t.DOC[a].getElementsByTagName('td').length; b++) {
                            t.DOC[a].getElementsByTagName('td')[b].classList.remove('seled');
                        };
                    }
                    if (newVal.length > 0) {
                        newVal.forEach(row => {
                            let i = t.tableParam.dataRes.entities.indexOf(row);
                            if (i >= 0) {
                                for (var b = 0; b < t.DOC[i].getElementsByTagName('td').length; b++) {
                                    t.DOC[i].getElementsByTagName('td')[b].classList.add('seled');
                                }
                            }
                        });
                    }
                }
            },
            // dheight(val, oldval) {
            //     if (this.tableParam.dataRes.entities == null) this.tableParam.dataRes.entities = [];
            //     if (val != 0 && oldval && this.tableParam.dataRes.entities.length > 0 && this.tableParam.isCurrentRow) {
            //         this.onScrollCurrentChange();
            //     }
            // }
        },
        mounted() {
            let t = this;
            t.$nextTick(() => {
                t.DOC = t.$el.getElementsByTagName('tbody')[0].children;
            });
        },
        methods: {
            isArray(obj){
                var str = Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
                return str === "array";
            },
            //上下键切换 ，让选中高亮行始终在可是区域内
            // onScrollCurrentChange() {
            //     let fixDiv = document.querySelector('.current-row');
            //     if(!fixDiv) return;
            //     let fixDivIndex = this.currentIndex + 2;
            //     let oneDivHeight = fixDiv.offsetHeight;
            //     let fixDivScrollTop = fixDivIndex * oneDivHeight + 28 + document.querySelector('.table-wrap').offsetTop - document.querySelector('.content').offsetTop;
            //     let divCurrentScrollTop = document.querySelector('.content').scrollTop;
            //     if (fixDivScrollTop - 26 - 48 < divCurrentScrollTop) {
            //         document.querySelector('.content').scrollTop = fixDivScrollTop - 26 * 3;
            //     } else if (divCurrentScrollTop < fixDivScrollTop - document.querySelector('.content').offsetHeight) {
            //         document.querySelector('.content').scrollTop = fixDivScrollTop - document.querySelector('.content').offsetHeight;
            //     } else if (this.currentIndex - 1 == 0) {
            //         document.querySelector('.content').scrollTop = 0;
            //     } else if (this.currentIndex == this.tableParam.dataRes.entities.length - 1) {
            //         document.querySelector('.content').scrollTop = document.querySelector('.content').scrollHeight - document.querySelector('.content').offsetHeight;
            //     }
            // },
            // 键盘事件
            onKeyDownChange(ev, key, data) {
                let t = this;
                if (key == 38) { // 上箭头键
                    ev.preventDefault();
                    if (t.currentIndex > 0) {
                        t.currentIndex--;
                        t.$refs.multipleTable.setCurrentRow(data.dataRes.entities[t.currentIndex]);
                        t.$emit('change', { event: 'upArrowKey', index: t.currentIndex, row: data.dataRes.entities[t.currentIndex] }); // 返回选中的数据
                    }
                } else if (key == 40) { // 下箭头键
                    ev.preventDefault();
                    if (t.currentIndex < data.dataRes.entities.length - 1) {
                        t.currentIndex++;
                        t.$refs.multipleTable.setCurrentRow(data.dataRes.entities[t.currentIndex]);
                        t.$emit('change', { event: 'downArrowKey', index: t.currentIndex, row: data.dataRes.entities[t.currentIndex] }); // 返回选中的数据
                    }
                } else if (key == 32) {  //空格键
                    ev.preventDefault();
                    // let doc = document.querySelector('.table-wrap .el-table__body').getElementsByTagName('tr');
                    if (t.DOC.length > 0 && !t.DOC[t.currentIndex].classList.contains('dis-ckb')) {
                        t.toggleSelection([t.currentRow]);
                        t.$emit('change', { event: 'spaceKey', row: t.currentRow }); // 返回选中的数据
                    }
                }
            },
            //表格的当前行发生变化的时候会触发该事件
            TrCurrentChange(currentRow, oldCurrentRow) {
                let t = this;
                // t.$el.stopPropagation();
                if (t.tableParam.isCurrentRow && currentRow) {
                    t.currentRow = currentRow;
                    t.currentIndex = t.tableParam.dataRes.entities.indexOf(currentRow);  //获取行索引
                    let isDisckb;
                    if (t.DOC.length > 0) {
                        isDisckb = t.DOC[t.currentIndex].classList.contains('dis-ckb');  //判断下一个是否有“.dis-ckb”禁用选中
                        let arr = t.selectRow;
                        t.selectRow = [];
                        t.$nextTick(function () { //该事件执行完毕之后
                            t.selectRow = arr;
                            if (isDisckb) { //避免高亮 时，把该有的禁用标识class过滤了，如果存在，重新加上
                                t.DOC[t.currentIndex].classList.add('dis-ckb');
                            }
                        });
                    }
                    t.$emit('change', { event: 'currentChange', index: t.currentIndex, row: t.tableParam.dataRes.entities[t.currentIndex] }); // 返回选中的数据
                }
            },
            //清除默认事件forEach
            clearEventBubble(evt) {
                if (evt.stopPropagation)
                    evt.stopPropagation();
                else
                    evt.cancelBubble = true;
                if (evt.preventDefault)
                    evt.preventDefault();
                else
                    evt.returnValue = false;
            },
            loadingOpen(ele) {  //loading open
                let parent = document.querySelector(ele || '.table-wrap');
                let child = document.querySelector(ele + '>.el-loading-mask');
                if (child) {
                    parent.removeChild(child);
                }
                this.loadingInstance = Loading.service({
                    target: parent,
                    spinner: 'el-icon-loading',
                    text: '加载中...',
                    background: 'rgba(255, 255, 255, 0.5)'
                });
                !ele ? ele = '.el-table__empty-text' : ele = ele + ' .el-table__empty-text';
                let a = document.querySelector(ele);
                if (a) {
                    a.style.display = "none";
                }
            },
            loadingClose(ele) { //loading close
                let t = this;
                t.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    t.loadingInstance.close();
                    !ele ? ele = '.el-table__empty-text' : ele = ele + ' .el-table__empty-text';
                    let a = document.querySelector(ele);
                    if (a) {
                        a.style.display = "block";
                    }
                });
            },
            toHtml(str) {
                return str;
            },
            handleEditorInput(row, val) {
                let t = this;
                t.rowIndex = t.tableParam.dataRes.entities.indexOf(row);
                t.editBeforeVal = val;
                t.editableCont = val;
                // t.editableCont = event.target.innerText;
                t.$set(t.tableParam.dataRes.entities[t.rowIndex], 'flag', true);
                clearTimeout(t.timer);
                t.timer = setTimeout(() => {
                    document.querySelectorAll('.editable')[t.rowIndex].focus();
                }, 300);
                t.timer = null;
            },
            bindtext($event) {  //把数据双向绑定
                let t = this;
                t.editableCont = $event.target.value;
            },
            editorEnterClick(index) { //回车
                let t = this;
                t.$set(t.tableParam.dataRes.entities[index], 'flag', false);
            },
            editorBlurFun(index, key, val, oldval) {    //失去焦点后
                let t = this;
                if (t.tableParam.dataRes.entities[index]) {
                    t.$set(t.tableParam.dataRes.entities[index], 'flag', false);
                }
                t.$emit('change', { event: 'getEditorCont', index: index, row: t.tableParam.dataRes.entities[index], key: key, val: val, oldval: oldval });
            },
            stopProgress(index) {
                let t = this;
                t.$emit('change', { event: 'stopProgress', index: index, row: t.tableParam.dataRes.entities[index] });
            },
            //行或列合并
            colsSpan({ row, column, rowIndex, columnIndex }) {
                let t = this;
                if (typeof t.callbackfn === 'function') {
                    return t.callbackfn({ row, column, rowIndex, columnIndex });
                } else {
                    return;
                }
            },
            //设置单元格的样式
            cellStyle({ row, column, rowIndex, columnIndex }) {
                let t = this;
                if (typeof t.cellcallback === 'function') {
                    return t.cellcallback({ row, column, rowIndex, columnIndex });
                } else {
                    return;
                }
            },
            //设置表头单元格的样式
            headerCellStyle({ row, column, rowIndex, columnIndex }) {
                let t = this;
                if (typeof t.cellcallback === 'function') {
                    return t.cellcallback({ row, column, rowIndex, columnIndex });
                } else {
                    return;
                }
            },
            //列单元格点击
            cellClick(row, column, cell, event) {
                let t = this;
                if (typeof t.cellclickcallback === 'function') {
                    return t.cellclickcallback({ row, column, cell, event });
                } else {
                    return;
                }
            },
            //表格列头点击
            headerClick(column, cell) {
                let t = this;
                if (typeof t.cellclickcallback === 'function') {
                    t.cellclickcallback({ column, cell });
                } else {
                    return;
                }
            },
            //匹配列
            addColumn(column) {
                let t = this;
                t.$emit('change', { event: 'addColumn', colum: column });
            },
            //渲染表头列的样式
            renderHeader(h,{column}){
                let t = this;
                if (typeof t.rendereadercallback === 'function') {
                    return t.rendereadercallback(h,{column});
                } else {
                    return;
                }
            },
            selectable(row, index) {  //禁止某一行 checked
                let t = this;
                let flag = true;
                t.$nextTick(() => {
                    // let doc = document.querySelector('.table-wrap .el-table__body').getElementsByTagName('tr');
                    if (t.DOC.length > 0) {
                        if (!row.isSelect && typeof row.isSelect != 'undefined') {
                            t.DOC[index].classList.add('dis-ckb');
                        } else {
                            t.DOC[index].classList.remove('dis-ckb');
                        }
                    }
                });
                if (!row.isSelect && typeof row.isSelect != 'undefined') {
                    flag = false;
                } else {
                    flag = true;
                }
                return flag;
            },
            selectChange(selectRow, row) { //选中某一行
                this.$emit('change', { event: 'selectSomeone', row: row });
                this.selectRow = selectRow;
            },
            selectAllChange(selection) { // 全选中
                this.$emit('change', { event: 'selectAll', row: selection });
                this.selectRow = selection;
            },
            // toggleSelection(rows){  //checked选中行
            //     let vm = this;
            //     if(rows.length>0){
            //         rows.forEach(row => {
            //             vm.$refs.multipleTable.toggleRowSelection(row, true);       
            //         });
            //     }else {
            //         vm.clearSelection();
            //     }
            //     vm.selectRow = rows;
            // },
            toggleSelection(rows) {  //checked选中行
                if (rows.length > 0) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
                // this.selectRow = rows;
            },
            // clearSelection(){
            //     let vm = this;
            //     vm.$refs.multipleTable.clearSelection();
            // },
            handleSelectionChange(selection) {  //当选择项发生变化时会触发该事件
                this.selectRow = selection;
                this.$emit('change', { event: 'selectionChange', rows: this.selectRow });
            },
            getSelection() {  // 获取选中行 数据
                return this.selectRow;
            },
            handleSizeChange(val) {
                this.tableParam.dataRes.currentPage = 1;
                // console.log(`${this.tableParam.dataRes.currentPage}每页 ${val} 条**** ${this.flag}`);
                this.$emit('change', { event: 'changeSize', pageSize: val });
            },
            handleCurrentChange(val) {
                this.$emit('change', { event: 'changePage', currentPage: val });
                // console.log(`${this.tableParam.dataRes.currentPage}当前页: ${val}**** ${this.flag}`);
            },
            sortChange(obj) {  //点击排序  ascending => asc     descending => desc
                let sortRule = {};
                !obj.order ? sortRule = {} : sortRule[obj.prop] = obj.order.replace(/\ending/, '');
                this.$emit('change', { event: 'sortChange', sortRule: JSON.stringify(sortRule) });
            },
            eventClick(event, index, row) {
                this.$emit('change', { event: event, index: index, row: row });
            },
            dropdownClick(index, row, key) {
                this.$emit('change', { event: 'dropdownclick', index, row, key });
            },
            getSingleRow(index, row) {
                this.$emit('change', { event: 'singleRow', index: index, row: row });
            }
        }
    };
</script>

<style lang='scss'>
    // @import 'src/style/common';

    .table-wrap {
        .el-table th.gutter {
            display: table-cell !important;
        }

        .el-table__body tr.current-row>td.seled,
        .el-table__body tr.hover-row.current-row>td.seled,
        .el-table__body tr.hover-row>td.seled,
        .el-table--striped .el-table__body tr.el-table__row--striped td.seled,
        .el-table--striped .el-table__body tr.el-table__row--striped.current-row>td.seled,
        .el-table__body tr>td.seled,
        .el-table--striped .el-table__body tr.el-table__row--striped>td.seled {
            background-color: #ecffe7;
        }

        .more-icon {
            position: absolute;
            top: 1px;
            display: inline-block;
            width: 29px;
            height: 16px;
            background: url(/images/more.png) no-repeat 0px 0px;
        }
    }

    .table-wrap,
    .el-popover {
        position: relative;
        background-color: #fff;

        .single_select {
            .el-radio__label {
                display: none;
            }
        }

        .el-loading-mask {
            z-index: 4;

            .el-loading-spinner {
                top: 50%;
                left: 0;
                margin-left: 0;
                background: transparent;
                margin-top: -27px !important;
                width: 100%;
                height: auto;
                text-align: center;
                position: absolute;

                i.el-icon-loading {
                    font-size: 16px;
                    color: #1589cf;
                }

                .el-loading-text {
                    font-size: 12px;
                    color: #1589cf;
                }
            }
        }
        .el-table--border {
            border-color: #ccd7ea;
            border-bottom-color: #ccd7ea;

            td:first-child .cell,
            th:first-child .cell {
                padding-left: 0px;
            }
        }

        .el-table--border::after,
        .el-table--group::after,
        .el-table::before {
            background-color: #ccd7ea;
        }

        .el-table {
            color: #333;
            font-size: 12px;
            border-radius: 4px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            thead {
                color: #3b455f;

                >tr {
                    height: 22px;
                    background-color: #e7edf6;

                    .cell {
                        height: 28px;
                        line-height: 28px;
                    }
                }
            }

            th {
                padding: 0;
                font-weight: bold;
                background-color: #e7edf6;
                text-overflow: initial;
            }
            tr{
                background-color: #f9fbfd;
            }

            th.is-leaf {
                border-bottom-color: #ccd7ea;
            }

            td {
                padding: 0;
            }

            .cell {
                padding: 0px 5px;
                height: 26px;
                line-height: 26px;
                white-space: nowrap;

                // -webkit-user-select:none; -moz-user-select:none; -ms-user-select:none; user-select:none;
                span.cont {
                    display: inline-block;
                    height: auto;
                    line-height: 22px;
                    min-width: 60px;
                }

                span.text_blue {
                    color: #2765b3;
                    cursor: pointer;
                }

                span.text_blue:hover {
                    text-decoration: underline;
                }

                .d-block {
                    display: block;
                    color: #2765b3;
                    text-decoration: underline;
                }

                .span-wrap .cont .el-button--mini {
                    padding: 3px 8px;
                }
                span.delbtn{
                    display: inline-block;
                    cursor: pointer;
                    background: #cfddee;
                    padding: 0px 5px;
                    line-height: 22px;
                    height:20px;
                    font-size:12px;
                    color: #2765b3;
                    border-radius: 2px;
                }
                .editable_input {
                    .editable {
                        font-size: 12px;
                        text-align: center;
                        margin: 0px 5px;
                        border: 1px solid rgba(201, 226, 255, 0.8);
                        background-color: rgba(155, 173, 255, 0.1);
                        box-shadow: 0 2px inset #ddd;
                    }

                    i.iconfont {
                        color: #b6d5f1;
                        font-size: 12px;
                        cursor: pointer;
                    }
                }

                .editable_input:hover {
                    i.iconfont {
                        color: #2765b3;
                    }
                }
            }

            .el-tooltip {
                >div {
                    height: 26px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            .el-switch.is-disabled {
                opacity: 1;

                .el-switch__core,
                .el-switch__label {
                    cursor: pointer;
                }
            }

            .caret-wrapper {
                height: 26px;

                .descending {
                    bottom: 2px;
                }

                .ascending {
                    top: 0px;
                }
            }
        }

        .el-table__body tr.current-row>td{
            background-color:transparent;
        }
        .el-table__body-wrapper {
            padding-bottom: 1px;
        }

        .el-table--striped .el-table__body tr.current-row {
            position: relative;
            height: 27px;
        }

        .el-table--striped .el-table__body tr:first-child {
            height: 27px;
        }

        .el-table--striped .el-table__body tr.current-row:first-child td .cell {
            top: 0px;
        }

        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td .cell,
        .el-table__body tr.current-row:first-child>td .cell,
        .el-table__body tr.current-row:last-child>td .cell,
        .el-table--striped .el-table__body tr.el-table__row--striped.current-row:last-child td .cell,
        .el-table__body tr.current-row:last-child>td .cell {
            height: 27px;
        }

        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td .cell,
        .el-table__body tr.current-row>td .cell {
            border-top: 1px solid #3582fb;
            border-bottom: 1px solid #3582fb;
            position: absolute;
            top: -1px;
            height: 28px;
            width: calc(100% + 1px);
            // margin-left:-0.5px;
        }

        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td:last-child .cell,
        .el-table__body tr.current-row>td:last-child .cell {
            border-right: 1px solid#3582fb;
            // height:25px;
            width: calc(100% - 1px);
            // padding-left:13px;
        }

        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td:first-child .cell,
        .el-table__body tr.current-row>td:first-child .cell {
            border-left: 1px solid #3582fb;
        }

        .el-table--border td,
        .el-table--border th,
        .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
            // border-bottom-color: none;
            border-right: 1px solid #ccd7ea;
            border-bottom: 1px solid #ccd7ea;
        }

        .el-table--striped .el-table__body tr.el-table__row--striped td,
        .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
            background: #e7edf6;
        }

        .el-table-column--selection:first-child .cell {
            padding: 0;
        }

        //进度条
        .el-table__body td .span-wrap {
            position: relative;
            height: 24px;

            .progress-wrap {
                width: 100%;
                position: relative;

                .el-progress {
                    float: left;
                    width: 165px;
                    margin-top: 9px;
                    .el-progress-bar__outer{
                        background-color: #cfd9e7;
                    }
                }

                .el-icon-error {
                    position: absolute;
                    top: 5px;
                    left: 165px;
                    font-size: 14px;
                    color: #f56c6c;
                    cursor: pointer;

                }

                .pre-text {
                    float: left;
                    font-size: 12px;
                    margin-left: 16px;
                    font-weight: 600;
                }
            }

            .icon-style {
                display: inline-block;

                .el-icon-circle-plus-outline {
                    font-size: 25px;
                    cursor: pointer;
                    color: #2765b3;
                    font-weight: 600;
                }
            }
        }

        .pagi-wrap.el-pagination {
            text-align: right;
            // border-left: 1px solid #b6d5f1;
            // border-right: 1px solid #b6d5f1;
            // border-bottom: 1px solid #b6d5f1;
            padding: 9px 5px;

            // background-color: $c36;
            .el-pagination__sizes {
                margin-right: 5px;
            }

            .el-pagination__jump {
                margin-left: 10px;
            }

            .btn-prev,
            .btn-next {
                padding: 0;
            }
            .el-pager li {
                color: #606266;
            }

            button,
            .el-pager li {
                min-width: 25px;
                height: 22px;
                line-height: 22px;
                font-size: 12px;
                // background-color: $c36;
            }

            .el-pagination button:disabled {
                color: #c0c4cc;
            }

            .el-pager li.active,
            button:hover,
            .el-pager li:hover {
                color: #409eff;
            }

            .el-select .el-input {
                width: 85px;
            }

            .el-pagination__editor.el-input {
                width: 40px;
                height: 22px;
            }

            span:not([class*=suffix]),
            .el-pagination__editor.el-input .el-input__inner,
            .el-input--mini .el-input__inner,
            .el-select-dropdown__item span {
                height: 22px;
                line-height: 22px;
                font-size: 12px;
            }

            .el-pager .more:before,
            .el-input--mini .el-input__icon {
                line-height: 22px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Components/TableList.vue